import { render, staticRenderFns } from "./DropdownCard.vue?vue&type=template&id=0705c7c4&scoped=true&"
import script from "./DropdownCard.vue?vue&type=script&lang=js&"
export * from "./DropdownCard.vue?vue&type=script&lang=js&"
import style0 from "./DropdownCard.vue?vue&type=style&index=0&id=0705c7c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0705c7c4",
  null
  
)

export default component.exports